import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, mt, pt} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";

import {hasAreaValidationError} from "../../../real_estate/utils/has_area_validation_error";
import {PropertyConfiguratorSearchFormValuesType} from "../../types/PropertyConfiguratorSearchFormValuesType";
import {PropertyConfiguratorFiltersForm} from "./PropertyConfiguratorFiltersForm";

interface IProps {
    isOpen: boolean;
    onClose: (value: boolean) => void;
    values: PropertyConfiguratorSearchFormValuesType;
    onChange: (value: Partial<PropertyConfiguratorSearchFormValuesType>) => void;
    handleChange: (name?: string, value?: unknown) => void;
}

export const MobileFiltersModal = ({isOpen, onClose, handleChange, ...filterProps}: IProps) => {
    return (
        <Modal css={modalWrapper} isOpen={isOpen} onModalClose={() => onClose(false)}>
            <Modal.Header variant="bar_mini">Twoje preferencje</Modal.Header>
            <Modal.Content>
                <div css={modalStyle}>
                    <PropertyConfiguratorFiltersForm {...filterProps} />
                    <Button
                        variant="filled_primary"
                        size="medium"
                        onClick={() => {
                            if (!hasAreaValidationError(filterProps.values.area)) {
                                onClose(false);
                                handleChange();
                            }
                        }}
                    >
                        Zapisz
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css`
    display: flex;
    flex-direction: column;
    ${mt(4)};
    gap: ${calculateRemSize(4)};

    .checkboxesSegmentStyle {
        ${pt(3)};
    }
`;

const modalWrapper = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        inset: 0;
    }
`;
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, mt, pt} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";

import {hasAreaValidationError} from "../../../real_estate/utils/has_area_validation_error";
import {PropertyConfiguratorSearchFormValuesType} from "../../types/PropertyConfiguratorSearchFormValuesType";
import {PropertyConfiguratorFiltersForm} from "./PropertyConfiguratorFiltersForm";

interface IProps {
    isOpen: boolean;
    onClose: (value: boolean) => void;
    values: PropertyConfiguratorSearchFormValuesType;
    onChange: (value: Partial<PropertyConfiguratorSearchFormValuesType>) => void;
    handleChange: (name?: string, value?: unknown) => void;
}

export const MobileFiltersModal = ({isOpen, onClose, handleChange, ...filterProps}: IProps) => {
    return (
        <Modal css={modalWrapper} isOpen={isOpen} onModalClose={() => onClose(false)}>
            <Modal.Header variant="bar_mini">Twoje preferencje</Modal.Header>
            <Modal.Content>
                <div css={modalStyle}>
                    <PropertyConfiguratorFiltersForm {...filterProps} />
                    <Button
                        variant="filled_primary"
                        size="medium"
                        onClick={() => {
                            if (!hasAreaValidationError(filterProps.values.area)) {
                                onClose(false);
                                handleChange();
                            }
                        }}
                    >
                        Zapisz
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = css`
    display: flex;
    flex-direction: column;
    ${mt(4)};
    gap: ${calculateRemSize(4)};

    .checkboxesSegmentStyle {
        ${pt(3)};
    }
`;

const modalWrapper = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        inset: 0;
    }
`;
